import { render, staticRenderFns } from "./FamousVirtualList.vue?vue&type=template&id=0bee1856&"
import script from "./FamousVirtualList.vue?vue&type=script&lang=js&"
export * from "./FamousVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports